/**
 * App entry point — Vite SPA root.
 *
 * MV3 guardrail: pure client-side, no SSR, no server on the render path.
 * This file must remain the only React mount point.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { App } from './App.js';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found. Check index.html.');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
